<template>
  <div
    class="u-16 grid around cross-around hor-padding-20"
    v-bar="{ preventParentScroll: true, scrollThrottle: 5, draggerThrottle: 5 }"
  >
    <div
      v-for="(item, index) in chartData.rows"
      :key="index"
      class="grid cross-center center bubble text-center margin-10"
      :style="{
        width: bubbleSize(item) + 'px',
        height: bubbleSize(item) + 'px',
        background: colors[item.id],
        fontSize: fontSize(item) + 'em'
      }"
    >
      <div>
        <span class="u-16 paymentsystem-name">{{
          item.code | filterName
        }}</span>
        <br />
        <span class="u-16 paymentsystem-percent">{{ item.percent }}%</span>
        <br />
        <span class="u-16 paymentsystem-count">{{
          item.count | filterAmount
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VCharts from "v-charts";
Vue.use(VCharts);
export default {
  name: "chartScatter",
  props: ["chartData"],
  data() {
    return {
      colors: [
        "#b4b4b4",
        "#4d71ef",
        "#ef4d7f",
        "#016FD0",
        "#1B458F",
        "#6C6BBD",
        "#000",
        "#F05713",
        "#2B9D3B",
        "#01d0c3",
        "#7c5691"
      ]
    };
  },
  filters: {
    filterAmount(value) {
      return value.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");
    },
    filterName(value) {
      return value == "American Express" ? "AMEX" : value;
    }
  },
  methods: {
    bubbleSize(item) {
      let size = (150 * parseFloat(item.percent)) / 100;
      return Math.max(size, 100);
    },
    fontSize(item) {
      return Math.max(parseFloat(item.percent) / 100, 0.8);
    }
  }
};
</script>

<style lang="sass" scope>
.bubble
  color: white
  line-height: 1.4
  padding: 20px
  border-radius: 50%
  .paymentsystem-name
    font-size: .8em
  .paymentsystem-percent
    font-size: 1.2em
    font-weight: 600
</style>
